if (typeof Promise.withResolvers === 'undefined') {
    Promise.withResolvers = function () {
      let resolve, reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve, reject };
    };
  }

const toFullfilledResult = (value) => ({ status: 'fulfilled', value });
const toRejectedResult = (reason) => ({ status: 'rejected', reason });

const toPromiseResult = (promiseOrValue) =>
  Promise.resolve(promiseOrValue)
    .then(toFullfilledResult)
    .catch(toRejectedResult)


if (typeof Promise.allSettled === 'undefined') {
    Promise.allSettled = function (promises) {
      return Promise.all(
        promises.map(toPromiseResult)
      );
    };
  }
  